/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const PinBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g clipPath="url(#a)"><path d="m17.071 9.757-3.535 3.536a4.985 4.985 0 0 0-1.415 2.828L7.88 11.88a4.942 4.942 0 0 0 2.828-1.415l3.536-3.535 2.828 2.828Zm3.536.707-7.071-7.07a1.003 1.003 0 0 0-1.415 0 1.003 1.003 0 0 0 0 1.414l.707.707L9.293 9.05a2.996 2.996 0 0 1-3.433.579c-.496-.242-1.126-.262-1.517.128a1 1 0 0 0 0 1.415l3.514 3.514-4.656 4.657a1 1 0 1 0 1.414 1.414L9.272 16.1l3.556 3.557a1 1 0 0 0 1.415 0c.39-.39.37-1.02.128-1.517a2.996 2.996 0 0 1 .579-3.433l3.535-3.535.707.707a1.003 1.003 0 0 0 1.415 0 1.003 1.003 0 0 0 0-1.415Z" /></g><defs><clipPath id="a"><path d="M0 0h24v24H0z" /></clipPath></defs></svg>);
const Pin = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={PinBase} {...rest} ref={ref} />);
export default Pin;